export const initializeApp = ({ restUrl, showFilter, setAppData, setUserData }) => {
	async function fetchData() {
		try {
			const response = await fetch(restUrl);
			const data = await response.json();
			setAppData(data);
			initUserData(showFilter, data, setUserData);
		} catch (error) {
			console.error(`There was an error initializing the jobs React app`, error);
		}
	}

	fetchData();
};

const initUserData = async (showFilter, appData, setUserData) => {
	const userData = {
		taxonomies: {},
	};

	if (showFilter) {
		const url = new URL(window.location);

		for (const [key, value] of url.searchParams) {
			if (key === 'q') {
				// Search query
				userData.taxonomies.q = value;
			} else if (key in appData.taxonomies) {
				// Taxonomy
				if (appData.taxonomies[key].terms.some((option) => option.slug === value)) {
					userData.taxonomies[key] = value;
				}
			}
		}
	}

	setUserData(userData);
};
